import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Typography,
} from "@material-tailwind/react";
import {
  LanguageIcon,
  ChevronRightIcon,
  CheckIcon,
} from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { Fragment } from "react";
import { getUserProfile, updateProfile } from "@/store/slices/userSlice";
import ShowLoader from "@/components/Loader";
import { setAppLanguage } from "@/utils/language";

const LanguageSubMenu = React.forwardRef((props, ref) => {
  const { t, i18n } = useTranslation("sidebar");
  const dispatch = useDispatch();

  const { user, loading } = useSelector((state) => state.user);

  const changeLanguage = async (lang) => {
    if(user?.language === lang) return;
    try {
      const payload = {
        id: user?.id,
        first_name: user?.first_name,
        email: user?.email,
        role: user?.roles[0],
        language: lang,
      };

      dispatch(updateProfile(payload)).unwrap().then((res)=>{
        if(res?.status){
          setAppLanguage(lang);
          dispatch(getUserProfile());
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Fragment>
      <Menu placement="right-start" allowHover>
        {loading && <ShowLoader />}
        <MenuHandler>
          <MenuItem {...props} ref={ref} className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <LanguageIcon className="h-5 w-5" />
              <Typography variant="small" className="font-semibold">
                 {t("languages")}
              </Typography>
            </div>

            <ChevronRightIcon className="h-4 w-4" />
          </MenuItem>
        </MenuHandler>

        <MenuList className="min-w-[180px]">
          <MenuItem
            onClick={() => changeLanguage("en")}
            className="flex items-center justify-between"
          >
            <span>🇬🇧 English</span>

            {i18n.language === "en" && (
              <CheckIcon className="h-4 w-4 text-green-600" />
            )}
          </MenuItem>

          <MenuItem
            onClick={() => changeLanguage("ar")}
            className="flex items-center justify-between"
          >
            
            <span>🇸🇦 العربية</span>

            {i18n.language === "ar" && (
              <CheckIcon className="h-4 w-4 text-green-600" />
            )}
          </MenuItem>
        </MenuList>
      </Menu>
    </Fragment>
  );
});

export default LanguageSubMenu;
